


import { Injectable } from '@angular/core';

import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ElCheckListServices {
    constructor(private http: HttpClient) {}
}
